/**
 * Copie un texte dans le presse-papier — avec repli.
 *
 * `navigator.clipboard.writeText` est REFUSÉ quand le « geste utilisateur » du
 * clic est perdu (Safari le perd dès qu'un `await` réseau s'intercale : générer
 * un lien PUIS le copier échoue) ou hors contexte sécurisé. Le repli
 * `document.execCommand('copy')` sur un `<textarea>` temporaire couvre ces cas.
 * Ne lève jamais : renvoie `true` si le texte est copié, `false` sinon (l'appelant
 * affiche alors le texte sélectionné pour une copie manuelle).
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // refusé (geste perdu, permission, contexte non sécurisé) → repli ci-dessous
  }
  return legacyCopy(text);
}

function legacyCopy(text: string): boolean {
  if (typeof document === 'undefined') return false;
  const el = document.createElement('textarea');
  try {
    el.value = text;
    el.setAttribute('readonly', '');
    // Hors écran mais sélectionnable ; taille de police 16px pour éviter le zoom auto d'iOS.
    el.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px';
    document.body.appendChild(el);
    el.select();
    el.setSelectionRange(0, text.length);
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    el.remove();
  }
}
